import { Component } from '@angular/core';
import { VantaAuthService } from '../core/services/vantaAuthService';

@Component({
  selector: 'app-auth-failed',
  templateUrl: './auth-failed.component.html',
  styleUrls: ['./auth-failed.component.scss'],
  imports: [],
})
export class AuthFailedComponent {
  public constructor(private readonly authService: VantaAuthService) {}

  public login(): void {
    this.authService.login();
  }
}
